//@service
import {bind,RepositoryInterface} from '@/service/utils'
export const ticketService= {
  get ticketRepository() {
    return bind(() => import('./ticketing.repo'), RepositoryInterface);
  },
    get ticketDetailsRepository() {
      return bind(() => import('./ticketingDetails.repo'), RepositoryInterface);
    },
    get allticketRepository() {
      return bind(() => import('./allticketing.repo'), RepositoryInterface);
    },
    get ticketAnswerRepository() {
      return bind(() => import('./ticketAnswer.repo'), RepositoryInterface);
    },
    get allTicketUnitRepository() {
      return bind(() => import('./allTicketUnit.repo'), RepositoryInterface);
    },
    get allTicketSmsRepository() {
      return bind(() => import('./allTicketSms.repo'), RepositoryInterface);
    },
    get ticketDoneRepository() {
      return bind(() => import('./ticketDone.repo'), RepositoryInterface);
    },
    get supportRepository() {
      return bind(() => import('./support.repo'), RepositoryInterface);
    },
    get contactUsWtRepository() {
      return bind(() => import('./contactUsWt.repo'), RepositoryInterface);
    },
    get contactUsRepository() {
      return bind(() => import('./contactUs.repo'), RepositoryInterface);
    },
    get faqRepository() {
      return bind(() => import('./faq.repo'), RepositoryInterface);
    },
    get ticketAccessRepository() {
      return bind(() => import('./ticketAccess.repo'), RepositoryInterface);
    },
}

